import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
import {
  Input,
  Radio,
  Tag,
  Typography,
  Avatar,
  Empty,
  Skeleton,
  Card,
  Space,
} from "antd";

const { Text } = Typography;

// Vive fuera del componente, asi que recibe `t` como argumento: un hook solo
// puede llamarse dentro de un componente.
function visibilityTag(v, t) {
  if (v === "global")
    return (
      <Tag color="purple">{t("asistenteEscena.paso1.visibilidadGlobal")}</Tag>
    );
  if (v === "public")
    return (
      <Tag color="blue">
        {t("asistenteEscena.paso1.visibilidadInstitucion")}
      </Tag>
    );
  return <Tag>{t("asistenteEscena.paso1.visibilidadPrivada")}</Tag>;
}

export function Step1SelectTherapy({
  loading,
  therapies,
  selectedTherapyId,
  onSelect,
  search,
  onSearch,
}) {
  const { t } = useTranslation(["rooms", "common"]);

  const data = useMemo(() => therapies || [], [therapies]);

  return (
    <div className="wizard-step">
      <div className="form-section">
        <h5>{t("asistenteEscena.paso1.titulo")}</h5>

        <Input.Search
          placeholder={t("asistenteEscena.paso1.buscarPlaceholder")}
          value={search}
          onChange={(e) => onSearch(e.target.value)}
          allowClear
        />
      </div>

      {loading ? (
        <Skeleton active paragraph={{ rows: 6 }} />
      ) : data.length === 0 ? (
        <Empty description={t("asistenteEscena.paso1.vacio")} />
      ) : (
        <Radio.Group
          value={selectedTherapyId}
          onChange={(e) => onSelect(e.target.value)}
          style={{ width: "100%" }}
        >
          <Space orientation="vertical" style={{ width: "100%" }} size={12}>
            {/*
              La variable del map se llamaba `t`, igual que la funcion de
              traduccion. Se renombra a `item` para que `t(...)` siga siendo la
              traduccion dentro del bucle.
            */}
            {data.map((item) => {
              const img = item?.image;
              const scenesCount = Array.isArray(item?.scenes)
                ? item.scenes.length
                : 0;

              return (
                <Card
                  key={item._id}
                  size="small"
                  hoverable
                  className={`revi-therapy-select-card ${
                    selectedTherapyId === item._id ? "is-selected" : ""
                  }`}
                  onClick={() => onSelect(item._id)}
                >
                  <Radio value={item._id} style={{ width: "100%" }}>
                    <div className="revi-therapy-select-row">
                      <Avatar
                        shape="square"
                        size={48}
                        src={img}
                        style={{ marginRight: 12 }}
                      />
                      <div className="revi-therapy-select-main">
                        <Text strong>
                          {item?.title ||
                            t("asistenteEscena.paso1.terapiaSinTitulo")}
                        </Text>

                        <div className="revi-therapy-select-meta">
                          {visibilityTag(item?.visibility, t)}
                          {/* Contador: en frances el cero va en singular. */}
                          <Tag>
                            {t("common:contadores.pasos", {
                              count: scenesCount,
                            })}
                          </Tag>
                        </div>
                      </div>
                    </div>
                  </Radio>
                </Card>
              );
            })}
          </Space>
        </Radio.Group>
      )}
    </div>
  );
}
